import { useEffect } from 'react';

import PropTypes from 'prop-types';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';

import Transition from '../Transition';
import { CLICKSTREAM_COMMON_PROPS } from '../utils/constants';

const ChatConnectionError = ({
  instructions,
  onRetry,
  onStartNew,
  showRetry = true,
  type = 'CONNECTION_ERROR'
}) => {
  const handlePageViewed = useClickstreamCallback('elementDisplayed', {
    ...CLICKSTREAM_COMMON_PROPS,
    elementName: 'error_ui'
  });

  useEffect(() => {
    handlePageViewed();
  }, [handlePageViewed]);

  return (
    <Transition
      actions={
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          {instructions.length > 0 && onRetry && showRetry && (
            <Button
              clickstreamProps={{
                ...CLICKSTREAM_COMMON_PROPS,
                elementName: 'retry_connection'
              }}
              color="primary"
              data-testid="retry-connection-button"
              variant="contained"
              onClick={onRetry}
            >
              Retry Connection
            </Button>
          )}
          {onStartNew && (
            <Button
              clickstreamProps={{
                ...CLICKSTREAM_COMMON_PROPS,
                elementName: 'start_new_conversation'
              }}
              color="primary"
              data-testid="start-new-conversation-button"
              variant="outlined"
              onClick={onStartNew}
            >
              Start New Conversation
            </Button>
          )}
        </Box>
      }
      type={type}
    />
  );
};

ChatConnectionError.propTypes = {
  instructions: PropTypes.array.isRequired,
  onRetry: PropTypes.func.isRequired,
  onStartNew: PropTypes.func.isRequired,
  showRetry: PropTypes.bool,
  type: PropTypes.string
};

export default ChatConnectionError;
